<template>
    <div>
        <div v-if="row.showGroupRow" class="title-row" :style="$options.titleRowStyle()">
            <div class="title-row-content">
                {{ $options.getGroupName(row) }}
                <a v-if="$options.getGroupUrl(row)" :href="$options.getGroupUrl(row)"
                    ><i class="icofont-ui-edit"></i
                ></a>
            </div>
        </div>
        <div class="item-row" :style="$options.getItemRowStyle(row)">
            <div class="title">
                <span class="name">{{ $options.getTitle(row) }}</span>
                <a class="name-edit" :href="$options.getUrl(row)"
                    ><i class="icofont-ui-edit"></i
                ></a>
            </div>
            <template v-if="currentZoom !== 0 && $options.getModeType() === 'planning'">
                <component
                    :is="$options.components.day"
                    v-for="(date, index) in $options.getDates()"
                    :key="index + '-' + date.formatted"
                    :date="date"
                    :item-id="$options.getItemId(row)"
                    :item-slots-mapping="$options.getItemSlotsMapping(row, date.formatted)"
                    :item-slots-group-mapping="$options.getItemsSlotsGroupMapping(row)"
                    :currentZoom="currentZoom"
                ></component>
            </template>


            <template
                v-if="currentZoom === 0 && $options.getModeType() === 'planning'"
            >
                <template
                    v-for="(date, index) in $options.getDates()"
                >
                    <component
                        v-for="(e, hour) in 24"
                        :index="'hour-' + hour"
                        :is="$options.components.HourComponent"
                        :key="index + '-' + date.formatted + '-' + hour"
                        :date="date"
                        :hour="hour"
                        :item-id="$options.getItemId(row)"
                        :item-slots-mapping="$options.getItemSlotsMapping(row, date.formatted)"
                        :item-slots-group-mapping="$options.getItemsSlotsGroupMapping(row)"
                    ></component>
                </template>
            </template>

            <template
                v-if="$options.getModeType() === 'capacity'"
            >
                <component
                    :is="$options.components.CapcityDayComponent"
                    v-for="(date, index) in $options.getDates()"
                    :key="index + '-' + date.formatted"
                    :date="date"
                    :item-id="$options.getItemId(row)"
                    :item-capacity="$options.getItemCapacity(row, date.formatted)"
                    :currentZoom="currentZoom"
                ></component>
            </template>
        </div>
    </div>
</template>

<script>
import store from '../../stores';

import day from './DayComponent';
import HourComponent from './HourComponent';
import CapcityDayComponent from './capacity/CapcityDayComponent';
import { MODE } from '../../constants';

export default {
    components: {
        day,
        HourComponent,
        CapcityDayComponent,
    },
    props: {
        row: {
            type: Object,
        },
        currentZoom: {
            type: Number,
        },
    },
    getDates() {
        return store.state.planning.dates;
    },
    getModeType: function () {
        const modeSettings = MODE[store.state.planning.mode];
        if (!modeSettings) {
            return;
        }
        return MODE[store.state.planning.mode].type;
    },
    getTitle(row) {
        const index = row.index;
        const itemsOrder = store.state.planning.itemsOrder;
        const itemId = itemsOrder[index];
        if (!itemId) {
            return '';
        }

        const item = store.state.planning.items[itemId];
        if (!item) {
            return '';
        }

        return item.title;
    },
    getGroupName(row) {
        const index = row.index;
        const itemsOrder = store.state.planning.itemsOrder;
        const itemId = itemsOrder[index];
        if (!itemId) {
            return '';
        }

        const item = store.state.planning.items[itemId];
        if (!item) {
            return '';
        }

        let title = item.group_title;

        if (item.group_subtitle) {
            title += ' | ' + item.group_subtitle;
        }
        return title;
    },
    getGroupId(row) {
        const index = row.index;
        const itemsOrder = store.state.planning.itemsOrder;
        const itemId = itemsOrder[index];
        if (!itemId) {
            return '';
        }

        const item = store.state.planning.items[itemId];
        if (!item) {
            return '';
        }

        return item.group_id;
    },
    getItemRowStyle(row) {
        const itemRowHeight = row.itemRowHeight;
        return {
            height: itemRowHeight + 'px',
        };
    },
    titleRowStyle() {
        return {
            width: store.state.planning.titleRowWidth + 'px',
        };
    },
    getItemId(row) {
        const index = row.index;
        const itemsOrder = store.state.planning.itemsOrder;
        const itemId = itemsOrder[index];
        if (!itemId) {
            return 0;
        }
        return itemId;
    },
    getItemSlotsMapping(row, date) {
        const index = row.index;
        const itemsOrder = store.state.planning.itemsOrder;
        const itemId = itemsOrder[index];
        if (!itemId) {
            return {};
        }

        if (!store.state.planning.itemsSlotsMapping[itemId]) {
            return {};
        }
        if (!store.state.planning.itemsSlotsMapping[itemId][date]) {
            return {};
        }
        return store.state.planning.itemsSlotsMapping[itemId][date];
    },
    getItemsSlotsGroupMapping(row) {
        const index = row.index;
        const itemsOrder = store.state.planning.itemsOrder;
        const itemId = itemsOrder[index];
        if (!itemId) {
            return {};
        }

        return store.state.planning.itemsSlotsGroupMapping[itemId];
    },
    getUrl: function (row) {
        const itemId = this.getItemId(row);
        if (!itemId) {
            return '';
        }
        const modeSettings = MODE[store.state.planning.mode];
        if (!modeSettings) {
            return '';
        }
        return route(modeSettings.linkRoute, itemId);
    },
    getGroupUrl(row) {
        const itemId = this.getItemId(row);
        if (!itemId) {
            return;
        }
        const modeSettings = MODE[store.state.planning.mode];
        if (!modeSettings) {
            return;
        }
        const sort = store.state.planning.sort;
        if (!sort) {
            return;
        }

        const sortSettings = _.find(modeSettings.sort, { sort: sort });
        if (!sortSettings) {
            return;
        }
        const routeName = sortSettings.route;
        if (!routeName) {
            return;
        }
        const groupId = this.getGroupId(row);
        if (!groupId) {
            return;
        }
        return route(routeName, groupId);
    },
    getItemCapacity(row, date) {
        const index = row.index;
        const itemsOrder = store.state.planning.itemsOrder;
        const itemId = itemsOrder[index];
        if (!itemId) {
            return false;
        }

        if (!store.state.planning.capacityItems[itemId]) {
            return false;
        }
        if (!store.state.planning.capacityItems[itemId][date]) {
            return false;
        }
        return store.state.planning.capacityItems[itemId][date];
    },
};
</script>

<style lang="scss">
.item-row {
    /*Changes wihtin row will not effect any outside elements*/
    /*The browser won't check, but we will change the transform of the other rows*/
    box-sizing: border-box;
    display: inline-flex;
    border-bottom: 1px solid #ccc;
    line-height: 25px;
    // min-height: 50px;
}

.title {
    box-sizing: border-box;
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    left: 0;
    width: 250px;
    background: #fff;
    border-right: 1px solid #ccc;
    padding-left: 10px;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    .name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .name-edit {
        margin-right: 5px;
        margin-left: 5px;
    }
}

.title-row {
    background: #777;
    // position: -webkit-sticky; /* for Safari */
    // position: sticky;
    z-index: 3;
    line-height: 25px;
}

.title-row-content {
    display: inline-block;
    background: #777;
    color: #fff;
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    top: 0px;
    left: 0px;
    z-index: 3;
    padding-left: 10px;
}
</style>
